module.exports = __webpack_public_path__ + "static/img/9.a8469ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/9.jpg
// module id = EI+w
// module chunks = 1